$(document).ready(function () {

// location button click event for searchform
    $('.location_button').on("click", function () {
        // get the location id which is the ID of the button
        var location_id = $(this).attr('id');
        var location_name = $(this).html();

        console.log('location info=' + location_id + ' - ' + location_name);

        // set the text visible to user
        $('#search_location_active').html(location_name);
        // set the id for filtering on backend
        $('#hidden_location_filter').val(location_id);
    })


// arrival date button click event for searchform
    $('.arrival_button').on("click", function () {

        // get the value from the selected button
        var arrival_filter = $(this).html().trim();

        console.log('arrival_filter info=' + arrival_filter);

        // set the text visible to user
        $('#search_arrival_date_active').html(arrival_filter);

        // set the id for filtering on backend
        // handle All, Past 24 hours, Past 3 days
        switch (arrival_filter) {
            case 'Past 24 hours':
                arrival_filter = 24;
                break;
            case 'Past 3 days':
                arrival_filter = 72;
                break;
            default:
                arrival_filter = '';
                break;
        }

        $('#hidden_arrival_date_filter').val(arrival_filter);
    });

// request date button click event for searchform
    $('.request_button').on("click", function () {

        // get the value from the selected button
        var request_filter = $(this).html().trim();

        console.log('request_filter info=' + request_filter);

        // set the text visible to user
        $('#search_request_date_active').html(request_filter);

        // set the id for filtering on backend
        // handle All, Past 24 hours, Past 3 days
        switch (request_filter) {
            case 'Past 24 hours':
                request_filter = 24;
                break;
            case 'Past 3 days':
                request_filter = 72;
                break;
            default:
                request_filter = '';
                break;
        }

        $('#hidden_request_date_filter').val(request_filter);
    });


// search button, calls validation function then submits form
    $('#search_button').on("click", function () {
        if (validate_form()) {
            $('#searchform_new').trigger("submit");
        } else {
            alert('not valid input');
        }
    });


// handle clicks for the menu options
    $('.aim-menu-link').on("click", function (event) {
        event.preventDefault();
        var menu_link_name = $(this).attr('id');

        // want to add the proper form value so we can filter records appropriately
        // depending on link
        switch (menu_link_name) {
            case 'awaiting_menu_link':
                $('#hidden_nav_filter').val('NEW');
                $('#has_searched').val(1);
                break;
            case 'new_inspections_menu_link':
                $('#hidden_nav_filter').val('PENDING');
                break;
            case 'auto_approved_menu_link':
                $('#hidden_nav_filter').val('APPROVED');
                break;
            case 'manual_approved_menu_link':
                $('#hidden_nav_filter').val('FEE-OPTION');
                break;
            case 'dispute_menu_link':
                $('#hidden_nav_filter').val('HOLD');
                break;
            case 'review_menu_link':
                $('#hidden_nav_filter').val('REVIEW');
                break;
            case 'withdrawn_menu_link':
                $('#hidden_nav_filter').val('WITHDRAWN');
                break;
            case 'unacceptable_menu_link':
                $('#hidden_nav_filter').val('COMMERCIALLY-UNACCEPTABLE');
                break;
            case 'complete_menu_link':
                $('#hidden_nav_filter').val('COMPLETE');
                break;
            default:
                break;
        }

        if (menu_link_name == 'awaiting_menu_link') {
            $('#basicSearchForm').find('input[type=checkbox]').each(function () {
                check_toggle = false;
                if (this.id == 'id_awaiting_inspections_checkbox') {
                    check_toggle = true;
                }
                $(this).prop('checked', check_toggle);
            }).promise().done( function() {
                $('#basicSearchForm').trigger("submit");
            });
        }
        else if (validate_form()) {
            $('#searchform_new').trigger("submit");
        } else {
            alert('not valid input');
        }
    });


    function validate_form() {
        // validates the form input before submitting
        is_valid = true;

        // check the hidden values
        console.log('hidden_location_filter=' + $('#hidden_location_filter').val());
        console.log('hidden_arrival_date_filter=' + $('#hidden_arrival_date_filter').val());
        if ($('#hidden_arrival_date_filter').val() == 'All') {
            $('#hidden_arrival_date_filter').val('');
        }

        console.log('hidden_request_date_filter=' + $('#hidden_request_date_filter').val());
        if ($('#hidden_request_date_filter').val() == 'All') {
            $('#hidden_request_date_filter').val('');
        }


        console.log('hidden_status_filter=' + $('#hidden_status_filter').val());
        console.log('hidden_vin=' + $('#hidden_vin').val());


        console.log('hidden_nav_filter=' + $('#hidden_nav_filter').val());
        console.log('hidden_location_filter=' + $('#hidden_location_filter').val());

        return is_valid;

    }

});